export default () => {
    let allHtml = document.querySelector('html'); 
    const lightboxes = document.querySelectorAll('.js-openLightBox');
    const lightBoxModal = document.querySelector('.js-LightBoxModal');

    if(lightboxes){
      lightboxes.forEach(lightbox => {
        lightbox.addEventListener('click', function() { 
          allHtml.style.overflow = 'hidden';
          lightBoxModal.classList.add('is-modal-open');
        }) 
      });
      if(lightBoxModal){
        let closenModal = document.querySelector('.js-CloseModal');  
        if(closenModal){
          closenModal.addEventListener('click', function(){
            lightBoxModal.classList.remove('is-modal-open');
            allHtml.style.overflow = 'auto';
          })              
        }
      }
    }
    
}